import { createContext } from "react";
import useLotDetailsByProjectIdStageIdLotId from "../hooks/data/useLotDetailsByProjectIdStageIdLotId";

export interface ILotDetailsContext extends ReturnType<typeof useLotDetailsByProjectIdStageIdLotId> {

};

const LotDetailsContext = createContext<ILotDetailsContext>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default LotDetailsContext